export default __webpack_public_path__ + "static/media/escrowtoken.026682c4.png";